module.exports = __webpack_public_path__ + "static/media/Page27.f553e820.png";